import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import SocialProof from '../components/SocialProof';
import Vision from '../components/Vision';
import WhatWeDo from '../components/WhatWeDo';
import Challenges from '../components/Challenges';
import Ecosystem from '../components/Ecosystem';
import ProductShowcase from '../components/ProductShowcase';
import WhyNexasolutra from '../components/WhyNexasolutra';
import Technology from '../components/Technology';
import Process from '../components/Process';
import FinalCTA from '../components/FinalCTA';
import { useViewTracking } from '../hooks/useViewTracking';

const HomePage: React.FC = () => {
  useViewTracking({ viewType: 'home' });

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, []);

  return (
    <div>
      <Hero />
      <SocialProof />
      <Vision />
      <WhatWeDo />
      <Challenges />
      <Ecosystem />
      <ProductShowcase />
      <WhyNexasolutra />
      <Technology />
      <Process />
      <FinalCTA />
    </div>
  );
};

export default HomePage;
